import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function TaxAccounting() {
  const { t } = useTranslation();

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>{t('services.service1.title')}</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="service-detail">
            <div className="service-description">
              <h2>Përshkrimi i Shërbimit</h2>
              <p>{t('services.service1.desc')}</p>
              <p>Shërbimi ynë i kontabilitetit të tatimeve përfshin:</p>
              <ul>
                <li>Përgatitja dhe paraqitja e deklaratave tatimore</li>
                <li>Optimizimi i tatimeve sipas ligjeve më të fundit</li>
                <li>Këshillim për planifikimin tatimor</li>
                <li>Përgatitja e raporteve financiare</li>
                <li>Mbështetje në rast auditimi tatimor</li>
              </ul>
            </div>
            
            <div className="service-benefits">
              <h2>Përfitimet</h2>
              <div className="benefits-grid">
                <div className="benefit-card">
                  <h3>Përvojë e Gjerë</h3>
                  <p>30+ vjet përvojë në fushën e tatimeve</p>
                </div>
                <div className="benefit-card">
                  <h3>Ekspertë të Certifikuar</h3>
                  <p>Ekipi ynë ka certifikimet e nevojshme</p>
                </div>
                <div className="benefit-card">
                  <h3>Përditësim i Vazhdueshëm</h3>
                  <p>Ndiqim ndryshimet në legjislacionin tatimor</p>
                </div>
                <div className="benefit-card">
                  <h3>Konfidencialitet i Plotë</h3>
                  <p>Mbrojmë informacionin e klientëve tanë</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TaxAccounting; 